import {Hero, type HeroProps} from '../../generic/Hero/Hero'

import Styles from './HeroSection.module.css'

export type HeroSectionProps = HeroProps

export const defaultProps: Partial<HeroSectionProps> = {}

export const HeroSection = (props: HeroSectionProps) => {
  const initializedProps: HeroSectionProps = {...defaultProps, ...props}

  return (
    <div className={Styles['HeroSection']}>
      <Hero {...initializedProps} />
      <div className={Styles['HeroSection__Spacer']} />
    </div>
  )
}
